module.exports = __webpack_public_path__ + "images/158_4096.jpg";